import React from 'react';
import SectionHeading from '../../Common/SectionHeading';
import Image from 'next/image';

const OurApproach = ({title=null}) => {
    return (
        <>
            <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-8 my-4">
                {(title) &&
                    <SectionHeading title={title}  customClass="text-center"/>
                }
                <p className="text-base">Supported by a dedicated team of primary research analysts, a range of primary research tools, and a panel of 7000+ KOLs and expert stakeholders, DelveInsight has designed a rich Competitive Intelligence-driven primary research methodology to analyze the changing trends in the market environment. Our Primary Research Services enable the client partners to remain up-to-date to enable success and revolutionize strategies.</p>
                <p className="text-base">DelveInsight’s operations are reinforced by a fundamental goal of securing the best-in-class primary research intelligence and helping clients in remaining customer-centric, understand market demands and consumer opinions, collect real-time relevant data, boost upselling opportunities, reduce risks, increase market share, gather expert insights, and gain a competitive advantage.</p>
                <h3 className='text-lg font-semibold text-center hidden lg:block mb-14 text-[#1b5df3]'>Driving Strategies of Primary Market Research Execution:</h3>
                <section className="container mb-30 mt-5 xl:mt-20 hidden lg:block h-[550px] 2xl:h-[600px]">
                    <div className="row">
                        <div id="line">
                            <div className="branch">
                                <Image 
                                    priority={false} 
                                    src={process.env.IMG_CDN+'img/primary-research/Survey-Designing-01.svg'}
                                    width={2000} 
                                    height={2000} 
                                    alt="Survey Designing"
                                />
                                <div className="content">
                                    <h4 className="text-lg font-semibold">Survey Designing</h4>
                                    <p className="text-base">Develop customized primary market research methodology to gain maximum insights from the relevant experts</p>
                                </div>
                            </div>
                            <div className="branch mirror-down turn">
                            <Image 
                                priority={false} 
                                src={process.env.IMG_CDN+'img/primary-research/Choosing-Target-Respondents-01.svg'}
                                width={2000} 
                                height={2000} 
                                alt="Choosing Target Respondents"
                            />
                                <div className="content">
                                    <h4 className="text-lg font-semibold">Choosing Target Respondents</h4>
                                    <p className="text-base">Leveraging the internal KOL panel, screening the most effective respondents for gathering accurate real-time data</p>
                                </div>
                            
                            </div>
                            <div className="branch">
                            <Image 
                                priority={false} 
                                src={process.env.IMG_CDN+'img/primary-research/Data-Collection-01.svg'}
                                width={2000} 
                                height={2000} 
                                alt="Data Collection" 
                            />
                                <div className="content">
                                    <h4 className="text-lg font-semibold">Data Collection</h4>
                                    <p className="text-base"> Utilizing proprietary tools to collect data in a time-sensitive manner to maintain a competitive advantage for the clients</p>
                                </div>
                            </div>
                            <div className="branch mirror-down turn">
                            <Image 
                                priority={false} 
                                src={process.env.IMG_CDN+'img/primary-research/Data-Processing-01.svg'}
                                width={2000} 
                                height={2000} 
                                alt="Data Processing" 
                            />
                                <div className="content">
                                    <h4 className="text-lg font-semibold">Data Processing</h4>
                                    <p className="text-base">Assessing all information to extract the most essential and strategic insights to provide clients with highly critical insights</p>
                                    
                                </div>
                            </div>
                            <div className="branch">
                            <Image 
                                priority={false} 
                                src={process.env.IMG_CDN+'img/primary-research/Data-Analysis-01.svg'}
                                width={2000} 
                                height={2000} 
                                alt="Data Analysis" 
                            />
                                <div className="content">
                                    <h4 className="text-lg font-semibold">Data Analysis</h4>
                                    <p className="text-base">Collate, synthesize and process insights and develop an understanding of opinions, creating intelligent outcome assessments</p>
                                </div>
                            </div>
                            <div className="branch mirror-down turn">
                                <Image 
                                    priority={false} 
                                    src={process.env.IMG_CDN+'img/primary-research/Insight-Generation-and-Presentation-01.svg'}
                                    width={2000} 
                                    height={2000}
                                    alt="Insight Generation and Presentation" 
                                
                                />
                                <div className="content">
                                    <h4 className="text-lg font-semibold">Insight Generation and Presentation</h4>                 
                                    <p className="text-base">Providing the ready-to-utilize deliverables that can be utilized by clients for strategic decision-making and road mapping.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            
        </>
    )
}
export default OurApproach;
